import {CustomValidatorComponent, FormComponentProps,} from "../../DynamicFormTypes.ts";
import React from "react";

export interface FieldToValidate {
    rawFieldKey: string,
    fieldKey: string,
    index?: number,
    dataGrid?: string
}
const CustomValidatorRenderer: React.FC<FormComponentProps<CustomValidatorComponent>> = ({ component }) => {
    console.debug(component)
    return null;
};

export const CustomValidator = React.memo(CustomValidatorRenderer);